var stickyHeader,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../../../../../core/frontend/groupon_modules/ariaKeyNavigation');

stickyHeader = require('../sticky_header');

Groupon.LS.Header.PNPrimaryNav = (function(superClass) {
  extend(PNPrimaryNav, superClass);

  function PNPrimaryNav($primaryNav) {
    this.$primaryNav = $primaryNav;
    this.setRailSlide = bind(this.setRailSlide, this);
    this.moveActiveMarker = bind(this.moveActiveMarker, this);
    this.openSubnav = bind(this.openSubnav, this);
    this.handleOpenSubnav = bind(this.handleOpenSubnav, this);
    this.initialize();
    this.bind();
  }

  PNPrimaryNav.prototype.initialize = function() {
    this.$primaryTabs = this.$primaryNav.find(".primary-nav-tab");
    if (!this.$headerV4) {
      this.setTabsDivider();
    }
    this.$subnavs = $('.subnav-flyout');
    this.localHeightCalculated = false;
    this.timeoutID = 0;
    this.$railSlide = $('#ls-rail-slide');
    this.enableActiveMarker = $('html.ui-v3').length;
    setTimeout(this.moveActiveMarker, 100);
    return this.setAriaAttributes();
  };

  PNPrimaryNav.prototype.bind = function() {
    var $primaryTabsLinks, cancelActiveMarkerTimer, cancelSubnavTimer, closeSubnav, eventType, moveMarkerOnResize, startsActiveMarkerTimer, startsSubnavTimer;
    if (Groupon.PageFlags.isLegacyResponsive) {
      moveMarkerOnResize = (function(_this) {
        return function() {
          return _this.moveActiveMarker();
        };
      })(this);
      $(window).on('resize', _.debounce(moveMarkerOnResize, 50));
    }
    closeSubnav = (function(_this) {
      return function() {
        if (!$('.primary-nav:hover').length) {
          _this.closeSubnav();
          window.clearTimeout(_this.timeoutID);
          if (!_this.enableActiveMarker) {
            _this.$railSlide.hide();
          }
        }
        return stickyHeader.resume();
      };
    })(this);
    startsSubnavTimer = (function(_this) {
      return function() {
        return _this.hovTimeout = setTimeout(closeSubnav, 50);
      };
    })(this);
    cancelSubnavTimer = (function(_this) {
      return function() {
        return clearTimeout(_this.hovTimeout);
      };
    })(this);
    startsActiveMarkerTimer = (function(_this) {
      return function() {
        return _this.activeMarkerTimeout = setTimeout(_this.moveActiveMarker, 50);
      };
    })(this);
    cancelActiveMarkerTimer = (function(_this) {
      return function() {
        return clearTimeout(_this.activeMarkerTimeout);
      };
    })(this);
    this.$primaryNav.on({
      mouseenter: function() {
        cancelSubnavTimer();
        return cancelActiveMarkerTimer();
      },
      mouseleave: function() {
        startsSubnavTimer();
        return startsActiveMarkerTimer();
      }
    });
    if (this.enableActiveMarker) {
      this.$primaryTabs.on({
        mouseenter: (function(_this) {
          return function(e) {
            cancelActiveMarkerTimer();
            return _this.moveActiveMarker($(e.currentTarget));
          };
        })(this)
      });
    }
    this.$subnavs.on({
      mouseenter: function() {
        cancelSubnavTimer();
        return cancelActiveMarkerTimer();
      },
      mouseleave: function() {
        startsSubnavTimer();
        return startsActiveMarkerTimer();
      }
    });
    eventType = 'mouseenter tap';
    $primaryTabsLinks = this.$primaryTabs.find('a').map(function() {
      if ($('#subnav-' + this.parentNode.id).length) {
        return this;
      }
    });
    if (Groupon.LS.hasTouch) {
      $primaryTabsLinks.on('tap', (function(_this) {
        return function(e) {
          var parent;
          parent = e.currentTarget.parentNode;
          e.preventDefault();
          e.stopImmediatePropagation();
          if ($('#subnav-' + parent.id).is(':visible')) {
            _this.closeVisibleSubnav();
          } else {
            $(parent).trigger('tap');
          }
          return false;
        };
      })(this));
      $('html').on('tap', (function(_this) {
        return function(e) {
          if ($('.subnav').height() && $(e.target).closest('.primary-nav, .subnav-flyout', '#ls-channel-nav').length === 0) {
            return _this.closeVisibleSubnav();
          }
        };
      })(this));
    }
    this.$primaryTabs.on(eventType, (function(_this) {
      return function(e) {
        e.stopPropagation();
        return _this.handleOpenSubnav(e);
      };
    })(this));
    return this.ariaBindMenuTrigger($primaryTabsLinks);
  };

  PNPrimaryNav.prototype.closeSubnav = function() {
    var ref;
    if ((ref = this.$currentFlyoutLinks) != null) {
      ref.attr('tabindex', '-1');
    }
    this.$subnavs.hide();
    return this.$primaryTabs.find('a.active').removeClass('active');
  };

  PNPrimaryNav.prototype.closeVisibleSubnav = function($activeTab) {
    if (!this.enableActiveMarker) {
      this.$railSlide.hide();
    }
    this.closeSubnav();
    if ($activeTab != null) {
      $activeTab.focus();
    }
    return this.$primaryTabs.find('a.active').removeClass('active');
  };

  PNPrimaryNav.prototype.handleOpenSubnav = function(e) {
    var $flyout, $tab, eventType, flyoutDelay, openSubnav;
    window.clearTimeout(this.timeoutID);
    flyoutDelay = $('.subnav-flyout').is(':visible') ? 0 : 300;
    $tab = $(e.currentTarget);
    if ($tab.is('a')) {
      $tab = $tab.parent();
    }
    eventType = e.type;
    $flyout = $("#subnav-" + ($tab.attr('id')));
    if (!$flyout.length || $flyout.not(".ls-s-flyout-enabled").length) {
      this.closeSubnav();
    }
    if ($flyout.length) {
      stickyHeader.pause();
      $('.typeahead-response').hide();
      openSubnav = (function(_this) {
        return function() {
          return _this.openSubnav($tab, $flyout, eventType);
        };
      })(this);
      if (flyoutDelay) {
        return this.timeoutID = setTimeout(openSubnav, flyoutDelay);
      } else {
        return openSubnav();
      }
    } else {
      if (!this.enableActiveMarker) {
        return this.$railSlide.hide();
      }
    }
  };

  PNPrimaryNav.prototype.openSubnav = function($tab, $flyout, eventType) {
    var $activeTab, $currentFlyoutLinks, $firstWidget, height;
    $activeTab = $tab.find('a').eq(0);
    $activeTab.addClass('active');
    if (!this.enableActiveMarker) {
      this.setRailSlide($activeTab);
    }
    $flyout.trigger('tab:active');
    $flyout.show();
    $flyout.find('.ls-lazy').lazyload();
    $firstWidget = $flyout.find('.subnav-megamind-widget:visible').eq(0);
    height = $firstWidget.width() / 440 * 420;
    if (eventType === 'keydown') {
      $currentFlyoutLinks = $flyout.find('a');
      $currentFlyoutLinks.attr('tabindex', '-1').eq(0).focus().attr('tabindex', '0');
      return this.initMenuNavigation($activeTab, $flyout, $currentFlyoutLinks);
    }
  };

  PNPrimaryNav.prototype.equalizeHeight = function($selector, maxHeight) {
    if (maxHeight == null) {
      maxHeight = 0;
    }
    $selector.css('height', '').each(function() {
      return maxHeight = Math.max(maxHeight, $(this).height());
    });
    return $selector.height(maxHeight);
  };

  PNPrimaryNav.prototype.moveActiveMarker = function($link) {
    var left, position, width;
    if ($link == null) {
      $link = this.$primaryTabs.filter('.default');
    }
    if (this.enableActiveMarker) {
      if (!$link.length) {
        $link = this.$primaryNav.find('.ls-current-app');
      }
      if ($link.is('li')) {
        $link = $link.find("a");
      }
      if ($link.length) {
        left = $link.position().left;
        position = left - 10;
        width = $link.width() + 20;
        return this.$railSlide.show().css('left', position).css('width', width);
      } else {
        return this.$railSlide.hide();
      }
    }
  };

  PNPrimaryNav.prototype.setRailSlide = function($link) {
    var center, left;
    if ($link.length) {
      left = $link.position().left;
      center = left + ($link.width() / 2);
      return this.$railSlide.show().css('left', center);
    }
  };

  PNPrimaryNav.prototype.setTabsDivider = function() {
    var $tabs, divider;
    divider = '<li class="p-nav-divider">|</li>';
    $tabs = this.$primaryNav.find('li');
    if ($tabs.length <= 4) {
      $tabs.eq(0).before(divider);
      $tabs.eq(-1).after(divider);
    }
    return $tabs.not(':last').after(divider);
  };

  PNPrimaryNav.prototype.ariaBindMenuTrigger = function($trigger) {
    $trigger.off('keydown');
    return $trigger.on('keydown', (function(_this) {
      return function(e) {
        var DOWN, SPACE, ref, ref1;
        ref = Groupon.Keymap, SPACE = ref.SPACE, DOWN = ref.DOWN;
        if ((ref1 = e.keyCode) === SPACE || ref1 === DOWN) {
          return _this.handleOpenSubnav(e);
        }
      };
    })(this));
  };

  PNPrimaryNav.prototype.ariaCloseMenu = function($trigger) {
    return this.closeVisibleSubnav($trigger);
  };

  PNPrimaryNav.prototype.setAriaAttributes = function() {
    var $subnav, $tab, i, len, ref, results, tab, tabID;
    ref = this.$primaryTabs;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      tab = ref[i];
      $tab = $(tab);
      tabID = tab.id;
      $subnav = $("#subnav-" + tabID);
      results.push(this.initAriaAttributes($tab.find('a'), $subnav, $subnav.find('a')));
    }
    return results;
  };

  return PNPrimaryNav;

})(Groupon.AriaMenuNavigation);

//# sourceMappingURL=data:application/json;base64,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
